var stickyHeader,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../../../../../core/frontend/groupon_modules/ariaKeyNavigation');

stickyHeader = require('../sticky_header');

Groupon.LS.Header.PNPrimaryNav = (function(superClass) {
  extend(PNPrimaryNav, superClass);

  function PNPrimaryNav($primaryNav) {
    this.$primaryNav = $primaryNav;
    this.setRailSlide = bind(this.setRailSlide, this);
    this.moveActiveMarker = bind(this.moveActiveMarker, this);
    this.openSubnav = bind(this.openSubnav, this);
    this.handleOpenSubnav = bind(this.handleOpenSubnav, this);
    this.initialize();
    this.bind();
  }

  PNPrimaryNav.prototype.initialize = function() {
    this.$primaryTabs = this.$primaryNav.find(".primary-nav-tab");
    if (!this.$headerV4) {
      this.setTabsDivider();
    }
    this.$subnavs = $('.subnav-flyout');
    this.localHeightCalculated = false;
    this.timeoutID = 0;
    this.$railSlide = $('#ls-rail-slide');
    this.enableActiveMarker = $('html.ui-v3').length;
    setTimeout(this.moveActiveMarker, 100);
    return this.setAriaAttributes();
  };

  PNPrimaryNav.prototype.bind = function() {
    var $primaryTabsLinks, cancelActiveMarkerTimer, cancelSubnavTimer, closeSubnav, eventType, moveMarkerOnResize, startsActiveMarkerTimer, startsSubnavTimer;
    if (Groupon.PageFlags.isLegacyResponsive) {
      moveMarkerOnResize = (function(_this) {
        return function() {
          return _this.moveActiveMarker();
        };
      })(this);
      $(window).on('resize', _.debounce(moveMarkerOnResize, 50));
    }
    closeSubnav = (function(_this) {
      return function() {
        if (!$('.primary-nav:hover').length) {
          _this.closeSubnav();
          window.clearTimeout(_this.timeoutID);
          if (!_this.enableActiveMarker) {
            _this.$railSlide.hide();
          }
        }
        return stickyHeader.resume();
      };
    })(this);
    startsSubnavTimer = (function(_this) {
      return function() {
        return _this.hovTimeout = setTimeout(closeSubnav, 50);
      };
    })(this);
    cancelSubnavTimer = (function(_this) {
      return function() {
        return clearTimeout(_this.hovTimeout);
      };
    })(this);
    startsActiveMarkerTimer = (function(_this) {
      return function() {
        return _this.activeMarkerTimeout = setTimeout(_this.moveActiveMarker, 50);
      };
    })(this);
    cancelActiveMarkerTimer = (function(_this) {
      return function() {
        return clearTimeout(_this.activeMarkerTimeout);
      };
    })(this);
    this.$primaryNav.on({
      mouseenter: function() {
        cancelSubnavTimer();
        return cancelActiveMarkerTimer();
      },
      mouseleave: function() {
        startsSubnavTimer();
        return startsActiveMarkerTimer();
      }
    });
    if (this.enableActiveMarker) {
      this.$primaryTabs.on({
        mouseenter: (function(_this) {
          return function(e) {
            cancelActiveMarkerTimer();
            return _this.moveActiveMarker($(e.currentTarget));
          };
        })(this)
      });
    }
    this.$subnavs.on({
      mouseenter: function() {
        cancelSubnavTimer();
        return cancelActiveMarkerTimer();
      },
      mouseleave: function() {
        startsSubnavTimer();
        return startsActiveMarkerTimer();
      }
    });
    eventType = 'mouseenter tap';
    $primaryTabsLinks = this.$primaryTabs.find('a').map(function() {
      if ($('#subnav-' + this.parentNode.id).length) {
        return this;
      }
    });
    if (Groupon.LS.hasTouch) {
      $primaryTabsLinks.on('tap', (function(_this) {
        return function(e) {
          var parent;
          parent = e.currentTarget.parentNode;
          e.preventDefault();
          e.stopImmediatePropagation();
          if ($('#subnav-' + parent.id).is(':visible')) {
            _this.closeVisibleSubnav();
          } else {
            $(parent).trigger('tap');
          }
          return false;
        };
      })(this));
      $('html').on('tap', (function(_this) {
        return function(e) {
          if ($('.subnav').height() && $(e.target).closest('.primary-nav, .subnav-flyout', '#ls-channel-nav').length === 0) {
            return _this.closeVisibleSubnav();
          }
        };
      })(this));
    }
    this.$primaryTabs.on(eventType, (function(_this) {
      return function(e) {
        e.stopPropagation();
        return _this.handleOpenSubnav(e);
      };
    })(this));
    return this.ariaBindMenuTrigger($primaryTabsLinks);
  };

  PNPrimaryNav.prototype.closeSubnav = function() {
    var ref;
    if ((ref = this.$currentFlyoutLinks) != null) {
      ref.attr('tabindex', '-1');
    }
    this.$subnavs.hide();
    return this.$primaryTabs.find('a.active').removeClass('active');
  };

  PNPrimaryNav.prototype.closeVisibleSubnav = function($activeTab) {
    if (!this.enableActiveMarker) {
      this.$railSlide.hide();
    }
    this.closeSubnav();
    if ($activeTab != null) {
      $activeTab.focus();
    }
    return this.$primaryTabs.find('a.active').removeClass('active');
  };

  PNPrimaryNav.prototype.handleOpenSubnav = function(e) {
    var $flyout, $tab, eventType, flyoutDelay, openSubnav;
    window.clearTimeout(this.timeoutID);
    flyoutDelay = $('.subnav-flyout').is(':visible') ? 0 : 300;
    $tab = $(e.currentTarget);
    if ($tab.is('a')) {
      $tab = $tab.parent();
    }
    eventType = e.type;
    $flyout = $("#subnav-" + ($tab.attr('id')));
    if (!$flyout.length || $flyout.not(".ls-s-flyout-enabled").length) {
      this.closeSubnav();
    }
    if ($flyout.length) {
      stickyHeader.pause();
      $('.typeahead-response').hide();
      openSubnav = (function(_this) {
        return function() {
          return _this.openSubnav($tab, $flyout, eventType);
        };
      })(this);
      if (flyoutDelay) {
        return this.timeoutID = setTimeout(openSubnav, flyoutDelay);
      } else {
        return openSubnav();
      }
    } else {
      if (!this.enableActiveMarker) {
        return this.$railSlide.hide();
      }
    }
  };

  PNPrimaryNav.prototype.openSubnav = function($tab, $flyout, eventType) {
    var $activeTab, $currentFlyoutLinks, $firstWidget, height;
    $activeTab = $tab.find('a').eq(0);
    $activeTab.addClass('active');
    if (!this.enableActiveMarker) {
      this.setRailSlide($activeTab);
    }
    $flyout.trigger('tab:active');
    $flyout.show();
    $flyout.find('.ls-lazy').lazyload();
    $firstWidget = $flyout.find('.subnav-megamind-widget:visible').eq(0);
    height = $firstWidget.width() / 440 * 420;
    if (eventType === 'keydown') {
      $currentFlyoutLinks = $flyout.find('a');
      $currentFlyoutLinks.attr('tabindex', '-1').eq(0).focus().attr('tabindex', '0');
      return this.initMenuNavigation($activeTab, $flyout, $currentFlyoutLinks);
    }
  };

  PNPrimaryNav.prototype.equalizeHeight = function($selector, maxHeight) {
    if (maxHeight == null) {
      maxHeight = 0;
    }
    $selector.css('height', '').each(function() {
      return maxHeight = Math.max(maxHeight, $(this).height());
    });
    return $selector.height(maxHeight);
  };

  PNPrimaryNav.prototype.moveActiveMarker = function($link) {
    var left, position, width;
    if ($link == null) {
      $link = this.$primaryTabs.filter('.default');
    }
    if (this.enableActiveMarker) {
      if (!$link.length) {
        $link = this.$primaryNav.find('.ls-current-app');
      }
      if ($link.is('li')) {
        $link = $link.find("a");
      }
      if ($link.length) {
        left = $link.position().left;
        position = left - 10;
        width = $link.width() + 20;
        return this.$railSlide.show().css('left', position).css('width', width);
      } else {
        return this.$railSlide.hide();
      }
    }
  };

  PNPrimaryNav.prototype.setRailSlide = function($link) {
    var center, left;
    if ($link.length) {
      left = $link.position().left;
      center = left + ($link.width() / 2);
      return this.$railSlide.show().css('left', center);
    }
  };

  PNPrimaryNav.prototype.setTabsDivider = function() {
    var $tabs, divider;
    divider = '<li class="p-nav-divider">|</li>';
    $tabs = this.$primaryNav.find('li');
    if ($tabs.length <= 4) {
      $tabs.eq(0).before(divider);
      $tabs.eq(-1).after(divider);
    }
    return $tabs.not(':last').after(divider);
  };

  PNPrimaryNav.prototype.ariaBindMenuTrigger = function($trigger) {
    $trigger.off('keydown');
    return $trigger.on('keydown', (function(_this) {
      return function(e) {
        var DOWN, SPACE, ref, ref1;
        ref = Groupon.Keymap, SPACE = ref.SPACE, DOWN = ref.DOWN;
        if ((ref1 = e.keyCode) === SPACE || ref1 === DOWN) {
          return _this.handleOpenSubnav(e);
        }
      };
    })(this));
  };

  PNPrimaryNav.prototype.ariaCloseMenu = function($trigger) {
    return this.closeVisibleSubnav($trigger);
  };

  PNPrimaryNav.prototype.setAriaAttributes = function() {
    var $subnav, $tab, i, len, ref, results, tab, tabID;
    ref = this.$primaryTabs;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      tab = ref[i];
      $tab = $(tab);
      tabID = tab.id;
      $subnav = $("#subnav-" + tabID);
      results.push(this.initAriaAttributes($tab.find('a'), $subnav, $subnav.find('a')));
    }
    return results;
  };

  return PNPrimaryNav;

})(Groupon.AriaMenuNavigation);

//# sourceMappingURL=data:application/json;base64,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
